var stickyHeader,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../../../../../core/frontend/groupon_modules/ariaKeyNavigation');

stickyHeader = require('../sticky_header');

Groupon.LS.Header.PNPrimaryNav = (function(superClass) {
  extend(PNPrimaryNav, superClass);

  function PNPrimaryNav($primaryNav) {
    this.$primaryNav = $primaryNav;
    this.setRailSlide = bind(this.setRailSlide, this);
    this.moveActiveMarker = bind(this.moveActiveMarker, this);
    this.openSubnav = bind(this.openSubnav, this);
    this.handleOpenSubnav = bind(this.handleOpenSubnav, this);
    this.initialize();
    this.bind();
  }

  PNPrimaryNav.prototype.initialize = function() {
    this.$primaryTabs = this.$primaryNav.find(".primary-nav-tab");
    if (!this.$headerV4) {
      this.setTabsDivider();
    }
    this.$subnavs = $('.subnav-flyout');
    this.localHeightCalculated = false;
    this.timeoutID = 0;
    this.$railSlide = $('#ls-rail-slide');
    this.enableActiveMarker = $('html.ui-v3').length;
    setTimeout(this.moveActiveMarker, 100);
    return this.setAriaAttributes();
  };

  PNPrimaryNav.prototype.bind = function() {
    var $primaryTabsLinks, cancelActiveMarkerTimer, cancelSubnavTimer, closeSubnav, eventType, moveMarkerOnResize, startsActiveMarkerTimer, startsSubnavTimer;
    if (Groupon.PageFlags.isLegacyResponsive) {
      moveMarkerOnResize = (function(_this) {
        return function() {
          return _this.moveActiveMarker();
        };
      })(this);
      $(window).on('resize', _.debounce(moveMarkerOnResize, 50));
    }
    closeSubnav = (function(_this) {
      return function() {
        if (!$('.primary-nav:hover').length) {
          _this.closeSubnav();
          window.clearTimeout(_this.timeoutID);
          if (!_this.enableActiveMarker) {
            _this.$railSlide.hide();
          }
        }
        return stickyHeader.resume();
      };
    })(this);
    startsSubnavTimer = (function(_this) {
      return function() {
        return _this.hovTimeout = setTimeout(closeSubnav, 50);
      };
    })(this);
    cancelSubnavTimer = (function(_this) {
      return function() {
        return clearTimeout(_this.hovTimeout);
      };
    })(this);
    startsActiveMarkerTimer = (function(_this) {
      return function() {
        return _this.activeMarkerTimeout = setTimeout(_this.moveActiveMarker, 50);
      };
    })(this);
    cancelActiveMarkerTimer = (function(_this) {
      return function() {
        return clearTimeout(_this.activeMarkerTimeout);
      };
    })(this);
    this.$primaryNav.on({
      mouseenter: function() {
        cancelSubnavTimer();
        return cancelActiveMarkerTimer();
      },
      mouseleave: function() {
        startsSubnavTimer();
        return startsActiveMarkerTimer();
      }
    });
    if (this.enableActiveMarker) {
      this.$primaryTabs.on({
        mouseenter: (function(_this) {
          return function(e) {
            cancelActiveMarkerTimer();
            return _this.moveActiveMarker($(e.currentTarget));
          };
        })(this)
      });
    }
    this.$subnavs.on({
      mouseenter: function() {
        cancelSubnavTimer();
        return cancelActiveMarkerTimer();
      },
      mouseleave: function() {
        startsSubnavTimer();
        return startsActiveMarkerTimer();
      }
    });
    eventType = 'mouseenter tap';
    $primaryTabsLinks = this.$primaryTabs.find('a').map(function() {
      if ($('#subnav-' + this.parentNode.id).length) {
        return this;
      }
    });
    if (Groupon.LS.hasTouch) {
      $primaryTabsLinks.on('tap', (function(_this) {
        return function(e) {
          var parent;
          parent = e.currentTarget.parentNode;
          e.preventDefault();
          e.stopImmediatePropagation();
          if ($('#subnav-' + parent.id).is(':visible')) {
            _this.closeVisibleSubnav();
          } else {
            $(parent).trigger('tap');
          }
          return false;
        };
      })(this));
      $('html').on('tap', (function(_this) {
        return function(e) {
          if ($('.subnav').height() && $(e.target).closest('.primary-nav, .subnav-flyout', '#ls-channel-nav').length === 0) {
            return _this.closeVisibleSubnav();
          }
        };
      })(this));
    }
    this.$primaryTabs.on(eventType, (function(_this) {
      return function(e) {
        e.stopPropagation();
        return _this.handleOpenSubnav(e);
      };
    })(this));
    return this.ariaBindMenuTrigger($primaryTabsLinks);
  };

  PNPrimaryNav.prototype.closeSubnav = function() {
    var ref;
    if ((ref = this.$currentFlyoutLinks) != null) {
      ref.attr('tabindex', '-1');
    }
    this.$subnavs.hide();
    return this.$primaryTabs.find('a.active').removeClass('active');
  };

  PNPrimaryNav.prototype.closeVisibleSubnav = function($activeTab) {
    if (!this.enableActiveMarker) {
      this.$railSlide.hide();
    }
    this.closeSubnav();
    if ($activeTab != null) {
      $activeTab.focus();
    }
    return this.$primaryTabs.find('a.active').removeClass('active');
  };

  PNPrimaryNav.prototype.handleOpenSubnav = function(e) {
    var $flyout, $tab, eventType, flyoutDelay, openSubnav;
    window.clearTimeout(this.timeoutID);
    flyoutDelay = $('.subnav-flyout').is(':visible') ? 0 : 300;
    $tab = $(e.currentTarget);
    if ($tab.is('a')) {
      $tab = $tab.parent();
    }
    eventType = e.type;
    $flyout = $("#subnav-" + ($tab.attr('id')));
    if (!$flyout.length || $flyout.not(".ls-s-flyout-enabled").length) {
      this.closeSubnav();
    }
    if ($flyout.length) {
      stickyHeader.pause();
      $('.typeahead-response').hide();
      openSubnav = (function(_this) {
        return function() {
          return _this.openSubnav($tab, $flyout, eventType);
        };
      })(this);
      if (flyoutDelay) {
        return this.timeoutID = setTimeout(openSubnav, flyoutDelay);
      } else {
        return openSubnav();
      }
    } else {
      if (!this.enableActiveMarker) {
        return this.$railSlide.hide();
      }
    }
  };

  PNPrimaryNav.prototype.openSubnav = function($tab, $flyout, eventType) {
    var $activeTab, $currentFlyoutLinks, $firstWidget, height;
    $activeTab = $tab.find('a').eq(0);
    $activeTab.addClass('active');
    if (!this.enableActiveMarker) {
      this.setRailSlide($activeTab);
    }
    $flyout.trigger('tab:active');
    $flyout.show();
    $flyout.find('.ls-lazy').lazyload();
    $firstWidget = $flyout.find('.subnav-megamind-widget:visible').eq(0);
    height = $firstWidget.width() / 440 * 420;
    if (eventType === 'keydown') {
      $currentFlyoutLinks = $flyout.find('a');
      $currentFlyoutLinks.attr('tabindex', '-1').eq(0).focus().attr('tabindex', '0');
      return this.initMenuNavigation($activeTab, $flyout, $currentFlyoutLinks);
    }
  };

  PNPrimaryNav.prototype.equalizeHeight = function($selector, maxHeight) {
    if (maxHeight == null) {
      maxHeight = 0;
    }
    $selector.css('height', '').each(function() {
      return maxHeight = Math.max(maxHeight, $(this).height());
    });
    return $selector.height(maxHeight);
  };

  PNPrimaryNav.prototype.moveActiveMarker = function($link) {
    var left, position, width;
    if ($link == null) {
      $link = this.$primaryTabs.filter('.default');
    }
    if (this.enableActiveMarker) {
      if (!$link.length) {
        $link = this.$primaryNav.find('.ls-current-app');
      }
      if ($link.is('li')) {
        $link = $link.find("a");
      }
      if ($link.length) {
        left = $link.position().left;
        position = left - 10;
        width = $link.width() + 20;
        return this.$railSlide.show().css('left', position).css('width', width);
      } else {
        return this.$railSlide.hide();
      }
    }
  };

  PNPrimaryNav.prototype.setRailSlide = function($link) {
    var center, left;
    if ($link.length) {
      left = $link.position().left;
      center = left + ($link.width() / 2);
      return this.$railSlide.show().css('left', center);
    }
  };

  PNPrimaryNav.prototype.setTabsDivider = function() {
    var $tabs, divider;
    divider = '<li class="p-nav-divider">|</li>';
    $tabs = this.$primaryNav.find('li');
    if ($tabs.length <= 4) {
      $tabs.eq(0).before(divider);
      $tabs.eq(-1).after(divider);
    }
    return $tabs.not(':last').after(divider);
  };

  PNPrimaryNav.prototype.ariaBindMenuTrigger = function($trigger) {
    $trigger.off('keydown');
    return $trigger.on('keydown', (function(_this) {
      return function(e) {
        var DOWN, SPACE, ref, ref1;
        ref = Groupon.Keymap, SPACE = ref.SPACE, DOWN = ref.DOWN;
        if ((ref1 = e.keyCode) === SPACE || ref1 === DOWN) {
          return _this.handleOpenSubnav(e);
        }
      };
    })(this));
  };

  PNPrimaryNav.prototype.ariaCloseMenu = function($trigger) {
    return this.closeVisibleSubnav($trigger);
  };

  PNPrimaryNav.prototype.setAriaAttributes = function() {
    var $subnav, $tab, i, len, ref, results, tab, tabID;
    ref = this.$primaryTabs;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      tab = ref[i];
      $tab = $(tab);
      tabID = tab.id;
      $subnav = $("#subnav-" + tabID);
      results.push(this.initAriaAttributes($tab.find('a'), $subnav, $subnav.find('a')));
    }
    return results;
  };

  return PNPrimaryNav;

})(Groupon.AriaMenuNavigation);

//# sourceMappingURL=data:application/json;base64,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
